<div class="flex flex-col max-w-240 md:min-w-160 -m-6 rounded-lg">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg">Folio de expediente</div>
        <button
            mat-icon-button
            (click)="dialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-4 sm:p-4 overflow-y-auto contenedor-formulario">
        <mat-form-field appearance="outline" class = "flex-initial w-full">
            <mat-label>Folio</mat-label>
            <input placeholder="Folio" matInput cleanWhiteSpace [(ngModel)]="folio">
        </mat-form-field>

        <div class = "flex-initial w-full">
            <p class="alert alert-secondary" *ngIf="expedientesConMismoNombre == -1">Verificando nombre de la persona registrada en el expediente...</p>
            <p class="alert alert-success" *ngIf="expedientesConMismoNombre == 0">No hay otros expedientes con el mismo nombre de la persona desaparecida</p>
            <p class="alert alert-warning" *ngIf="expedientesConMismoNombre > 0">{{'Hay ' + expedientesConMismoNombre + ' expediente(s) con el mismo nombre de la persona desaparecida: ' + strFolios}}</p>
        </div>

    </div>
    <div class="flex flex-row p-6 sm:p-8 justify-end items-end content-end">
        <button class="mr-8" mat-raised-button type="button" (click)="dialogRef.close()">
            Cancelar
        </button>
        <button (click)="save()" mat-raised-button type="button" color="accent" [disabled]="verificando || (!folio || !(folio !== ''))">
            Guardar
        </button>
    </div>
</div>

